const flow = require('lodash/fp/flow');
const map = require('lodash/fp/map');
const fromPairs = require('lodash/fp/fromPairs');
const padCharsStart = require('lodash/fp/padCharsStart');


const trueMap = flow(map(field => [field, true]), fromPairs);

class EditPaymentController {
  static get $inject() {
    return ['$scope', '$stateParams', '$q', 'paymentService', 'billingAddress', 'toastService'];
  }

  constructor($scope, $stateParams, $q, paymentService, billingAddress, toastService) {
    this.$scope = $scope;
    this.$q = $q;
    this.paymentService = paymentService;
    this.toastService = toastService;

    this.payment = $stateParams.payment;
    this.payment.billingAddress = billingAddress;
  }

  $onInit() {
    this.payment.ccNumber = padCharsStart('X', 16, this.payment.ccNumberEnding);

    this.useForAll = true;

    this.disabledCCFields = trueMap(['ccHolder', 'ccType', 'ccCardNumber']);
  }

  submit(payment, useForAll) {
    let result = this.$q.when();
    if (useForAll) {
      result = result.then(() => this.paymentService.useForAll(payment.publicId));
    }

    return result
      .then(() => this.paymentService.update(payment))
      .then(() => this.toastService.translate.success('TOAST_CHANGE_BILLING_SUCCESS'))
      .then(this.$scope.$close)
      .catch(() => {
        this.toastService.translate.danger('TOAST_CHANGE_BILLING_DANGER');
      });
  }
}

angular.module('msi.payments.edit')
  .controller('EditPaymentController', EditPaymentController);

module.exports = EditPaymentController;
